import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReprojection = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M36.553 11.447 24 6.247l-12.553 5.2L6.247 24l5.2 12.553L24 41.753l12.553-5.2L41.753 24zM9.151 9.151 24 3l14.849 6.151L45 24l-6.151 14.85L24 45 9.151 38.85 3 24zm8.003 11.054a3.051 3.051 0 1 0 0-6.102 3.051 3.051 0 0 0 0 6.102m16.168 16.746-22.545-4.639 2.528-7.252-5.998.686-.114-.993 6.478-.741 1.107-3.177.944.33-.948 2.72 24.349-2.787zM14.408 24.934l-2.31 6.629 20.581 4.235 4.948-13.522z" })
});
export default SvgReprojection;
